import * as React from 'react';

import * as styles from './DesktopSearchBlockLayout.css';

export const DesktopSearchBlockLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
